import { configureStore } from "@reduxjs/toolkit";
import notificationSlice from "./reducers/notificationSlice";
export const store = configureStore({
  reducer: {
    notification: notificationSlice,
  },
});

export default store;
